import { FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { UtilsService } from '@common/services';

export function inputSensorids9Validator (errorMsg: string = 'SENSORSID'): ValidatorFn
{
    return (formControl: FormControl): ValidationErrors | null =>
    {
        const input: string = formControl.value;
        if (UtilsService.isNullOrEmpty(input))
        {
            return null;
        }

        const ids: string[] = input.split(',');
        const valid: boolean = ids.reduce(
            (prev: boolean, curr: string): boolean => prev && /^\d+$/.test(curr),
            true
        );
        if (!valid)
        {
            const validationErrors: ValidationErrors = { sensorIds: true };

            validationErrors.errorMsg = errorMsg;

            return validationErrors;
        }

        return null;
    };
}
